var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03852 10.0334L9.97438 13.0643L11.7626 12.0305L9.22025 8.03301L8.03852 10.0334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3928 10.8151L13.3915 9.98684L10.6135 5.67045L9.58288 7.41505L12.2647 11.7417L13.2343 11.1813C13.3294 11.1042 13.3869 10.9912 13.393 10.8691L13.3928 10.8151Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75004 11.5959L3.11931 12.3829L7.67594 5.09308L6.90254 5.07271C6.24364 5.06342 5.53384 5.23429 5.20806 5.76482L2.62051 9.7657L1.75 11.1001L1.75004 11.5959Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3058 5.09308L8.26766 5.10046L3.65644 12.6914L5.26764 13.6178L5.70646 12.8755L10.3058 5.09308Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 5.08278C14.233 4.65756 14.0022 4.26824 13.6407 4.04164L8.5737 1.13484C8.21609 0.955187 7.76936 0.954964 7.41118 1.13471C7.36882 1.156 2.48364 3.98238 2.48364 3.98238C2.41605 4.0147 2.35094 4.05324 2.28966 4.09695C1.96693 4.32767 1.77021 4.6862 1.75 5.08017V11.1001L2.62051 9.7657L2.61288 5.1207C2.61393 5.1037 2.61611 5.08684 2.61907 5.0703C2.63884 4.96103 2.69999 4.86367 2.79202 4.7978C2.81501 4.78139 7.78362 1.91233 7.79944 1.90443C7.91617 1.84591 8.06455 1.8453 8.18154 1.90265L13.1829 4.77254C13.3013 4.84776 13.3755 4.97522 13.382 5.11452L13.3821 10.8688C13.376 10.9908 13.3277 11.1037 13.2326 11.1807L12.2629 11.7412L11.7626 12.0305L9.97438 13.0643L8.16087 14.1128C8.06321 14.1479 7.94896 14.1459 7.85213 14.1067L5.70646 12.8755L5.26764 13.6178L7.19639 14.7248C7.26012 14.761 7.31696 14.793 7.36359 14.8191C7.4358 14.8596 7.48498 14.8865 7.50234 14.8949C7.63936 14.9613 7.83654 15 8.01426 15C8.17718 15 8.33602 14.9702 8.48637 14.9114L13.7538 11.8683C14.0561 11.6346 14.234 11.2822 14.25 10.9005V5.08278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrumLogo);
export default __webpack_public_path__ + "static/media/arbitrumLogo.eb019723678a256b08f73d12bc3ceec0.svg";
export { ForwardRef as ReactComponent };